<a
  *wlGenericLink="link()"
  class="top-task__button d-flex flex-column justify-content-center p-2"
>
  <crnt-icon
    [icon]="iconValue() ?? 'question'"
    class="top-task__button-icon mb-1"
  />
  <span class="top-task__button-text">{{ linkText() }}</span>
</a>
